import styled from 'styled-components';
const ResultListStyled = styled.div`
  .table-wrapper {
    .table-content {
      padding: 0;
    }
  }
`;
export default ResultListStyled;
